// extracted by mini-css-extract-plugin
export default {"container":"BPtCollapseDialog-module_container_b6a5b644","radio":"BPtCollapseDialog-module_radio_f2246c5e","panelItem":"BPtCollapseDialog-module_panelItem_b62ac7db"};